import { db } from './../../../config/Fire';
import * as Constants from './../../../constants/nodes_database';

export const SET_TYPES = 'SET_TYPES';

const setTypes = payload => ({ type: SET_TYPES, payload });

export const setTypesToState = payload => {
    return dispatch => {
        return db.ref(`${Constants.TYPES}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists() && snapshot.val() !== null) {
                    var typesSnap = snapshot.val();
                    var types = [];
                    typesSnap.forEach(type => {
                        types.push(type);
                    });
                    dispatch(setTypes(types));
                } else {
                    console.log("snapshot: " + snapshot);
                    dispatch(setTypes([]));
                }
            })
            .catch(err => {
                console.log ('Error getting user: ', err);
                dispatch(setTypes([]));
        });
    };
};